import React, { useEffect } from 'react'

import { APP_VERSION } from '../../../../config/const'

import { Alert, Button } from 'antd'
import { useUserSession } from '../../../../hooks/useUserSession'
import { useQueryClient } from '@tanstack/react-query'

const UpdateBanner = ({ addPaddingTop }) => {
  const { data, isLoading } = useUserSession()
  const queryClient = useQueryClient()

  const reload = () => {
    queryClient.invalidateQueries('userSession')
    // props.expire()
    window.location.reload(true)
  }

  useEffect(() => {
    const { version } = data
    if (!isLoading && version !== undefined && data?.version != APP_VERSION ) {
      addPaddingTop(40)
    }
  }, [isLoading, data, addPaddingTop])

  if (isLoading) {
    return
  }
  const { version } = data
  const newVersion = data?.version != APP_VERSION

  if (version !== undefined && newVersion) {
    const message = `"Version ${data.version} was released, please update the app. `

    return (
      <Alert
        type='info'
        message={message}
        banner
        action={
          <Button size='small' type='primary' onClick={reload}>
            Update App
          </Button>
        }
      />
    )
  }

  return null
}

export default UpdateBanner
